module.exports = __webpack_public_path__ + "static/media/flecha_white.ba47854e.svg";